var notices = require('../../notices')
var menu = require('../../menu')
var request = require('../../request')
var raygun = require('../../raygun');

var miniModalCurrentShown = null
var miniModalCurrentShownTimeoutID = null
var miniModalActiveURL = null

// TBC
// Given there is an ajax call
// When the call is started
// Then show the spinner

var onloadstartHandler = function () {
  // console.log("Show spinner")
}

// TBC
// Given there is an ajax call in progress
// When there is a progress event
// Then update the textContent in the progressbar

var onprogressHandler = function (e) {
  //console.log("Show spinner" + (e.loaded / e.total * 100 >> 0))
}

// TBC
// Given there is an ajax call
// When the call is completed
// Then hide the progressbar

var onloadendHandler = function () {
  //console.log("Hide spinner")
}

// When the response status is not 200 (success)
// Then display an error notice
var reject = function () {
  notices.warn()
  modal.destroy()
}

// Given the URL for the modal
// When the URL returns a response containing a modal
// Then display the modal

// Given the URL for the modal
// When the fails
// Then display an error notice

var resolve = function (data) {
  activeRequest = false

  var content = new DOMParser().parseFromString(data.html, 'text/html')
  var dynamicModal = content.getElementById('modal')
  // Create a DOM element in the correct context
  insertMiniModalIntoDOM(data.miniModalEl, document.createRange().createContextualFragment(dynamicModal.innerHTML))
  // Go and get the next one
  addToLoadQueue()
}

var errorHandling = function (e) {
  activeRequest = false
  notices.warn(e)
  // Go and get the next one ~ assuming the error is isolated
  addToLoadQueue()
}

var queue = []
var activeLoadingItem  // The active item
function addToLoadQueue(miniModalEl) {
  if (miniModalEl) {
    // Filter out Active items or duplicates
    // This occurs with multiple requests from hover events or a slow network
    if (activeLoadingItem === miniModalEl || queue.length && queue.indexOf(miniModalEl) >= 0) {
      return
    }

    queue.push(miniModalEl)
    if (queue.length > 1 || activeRequest) {
      // Currently processing a request
      return
    }
  } else {
    // Reset
    activeLoadingItem = null
  }

  if (queue.length) {
    activeLoadingItem = queue.shift()
    load(activeLoadingItem)
  }
}

var activeRequest = false
function load(miniModalEl) {
  var url = miniModalEl.dataset.miniModal
  activeRequest = true
  request.get(url, {onloadstartHandler:onloadstartHandler, onprogressHandler:onprogressHandler})
    .then(function (res) {
      onloadendHandler()
      return res
    })
    .then(function (res) {
      var data = {html:res, modalLoadingURL:url, miniModalEl:miniModalEl}
      resolve(data)
    })
    .catch(function (err) {
      raygun.sendError(err, 'modalMiniLoad');
      errorHandling(err)
    })
}

function insertMiniModalIntoDOM(el, miniModal) {
  if (!el.cmMiniModalInst) {
    // Insure we only insert this once
    el.insertAdjacentElement('beforeend', miniModal.querySelector('div')) // Get the firstElementChild of the DocumentFragment
    el.cmMiniModalInst = el.lastElementChild
  }
  if (el.dataset.miniModal == miniModalActiveURL) {
    // We have loaded mini modal into the DOM and now can display it
    displayMinModal(el.cmMiniModalInst, true)
  }
}

function isElementBelowViewport(element, padding) {
  var padding = padding ? padding : 0

  var bottomOfMiniModal = element.getBoundingClientRect().y + element.getBoundingClientRect().height + padding
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

  return bottomOfMiniModal > viewHeight;
}

function displayMinModal(el, state) {
  // Show the mini modal
  el.hidden = !state

  // Set the position of the mini modal
  // Check if we need to move the position of the mini modal so that it is in the view port
  el.style.top =  isElementBelowViewport(el, 20) ? (-1 * el.getBoundingClientRect().height + 'px') : '100%'

  miniModalCurrentShown = (state ? el : null)
  if (miniModalCurrentShownTimeoutID) {
    window.clearTimeout(miniModalCurrentShownTimeoutID)
    miniModalCurrentShownTimeoutID = null
  }

  if (!state) {
    menu.closeMenu()
  }
}

function show(miniModalEl, state) {

  // If we are showing a modal close it
  closeMiniModal()

  if (miniModalEl.cmMiniModalInst) {
    // We have the content already show it
    displayMinModal(miniModalEl.cmMiniModalInst, state)
  } else {
    // Go get the modal and show it
    addToLoadQueue(miniModalEl)
  }

}

function click(ev) {
  var target = ev.target.closest('[data-mini-modal]')
  if (target) {
    miniModalActiveURL = target.dataset.miniModal
    if (ev.target.closest('[data-mini-modal-instance]')) {
      // let the events flow throw

    } else {
      ev.preventDefault()

      show(target, target.cmMiniModalInst && target.cmMiniModalInst.hidden)
    }

  } else {
    // Close it if we have one
    closeMiniModal()
  }
}

function mouseoverMiniModalTarget(ev) {
  var currentTarget = ev.currentTarget
  miniModalActiveURL = currentTarget.dataset.miniModal
  if (currentTarget.cmMiniModalInst ===  miniModalCurrentShown) {
    // Clear the timer
    if (miniModalCurrentShownTimeoutID) {
      window.clearTimeout(miniModalCurrentShownTimeoutID)
      miniModalCurrentShownTimeoutID = null
    }
  } else {
    // Show the instance
    show(currentTarget, true)
  }
}

var closeMiniModal = function() {
  // Close it if we have one
  miniModalCurrentShown && displayMinModal(miniModalCurrentShown, false)
}
exports.closeMiniModal = closeMiniModal

function mouseoutMiniModalTarget(ev) {
  miniModalCurrentShownTimeoutID = window.setTimeout(
    function(){
      closeMiniModal()
    }, 500)
}

function init() {
  // Attach hover listeners
  Array.from(document.querySelectorAll('[data-mini-modal]')).forEach(function(node) {
    node.addEventListener('mouseover', mouseoverMiniModalTarget)
    node.addEventListener('mouseleave', mouseoutMiniModalTarget)
  })
}

document.addEventListener('click', click)
document.addEventListener('DOMContentLoaded', init)
